import React from 'react'
import { Color, Direction } from '../../../utils/constants'
import Chevron from '../../Chevron'
import Button, { ButtonSize } from '../Button'
import { twMerge } from 'tailwind-merge'

interface ArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction: Direction
  buttonColor?: Color
  size?: ButtonSize
  isInverted?: boolean
}

const ArrowButton = ({
    direction,
    buttonColor = Color.WHITE,
    size = ButtonSize.SMALL,
    disabled,
    className,
    isInverted,
    ...props
}: ArrowButtonProps) => {
    const getPadding = () => {
        switch (size) {
        case ButtonSize.SMALL:
            return 'p-4 group-hover:p-4 group-hover:m-0'
        case ButtonSize.MEDIUM:
            return 'p-[22px] md:p-8 group-hover:p-7'
        case ButtonSize.LARGE:
            return 'p-16 group-hover:p-[3.75rem]'
        }
    }

    const getColor = () => {
        switch (buttonColor) {
        case Color.WHITE:
            return size === ButtonSize.LARGE
                ? 'bg-white/20 text-white fill-white group-hover:bg-white/20 stroke-white'
                : twMerge(
                    isInverted ? 'stroke-black' : 'stroke-white',
                    disabled
                        ? 'disabled:group-hover:bg-transparent'
                        : 'group-hover:bg-white group-hover:text-black group-hover:fill-black group-hover:stroke-black',
                )
        case Color.BLACK:
            return twMerge(
                disabled
                    ? 'group-hover:bg-transparent opacity-50'
                    : 'group-hover:bg-black group-hover:stroke-white group-hover:text-white group-hover:fill-white',
                'bg-transparent text-black fill-white stroke-black',
            )
        }
    }

    const getBorder = () => {
        if (buttonColor === Color.WHITE) {
            return 'border-white/20'
        } else if (buttonColor === Color.BLACK && disabled) {
            return 'border-black/20'
        }
    }

    return (
        <Button
            outerClasses={twMerge(getBorder(), className)}
            innerClasses={twMerge(getPadding(), getColor())}
            buttonColor={buttonColor}
            disabled={disabled}
            isInverted={isInverted || size !== ButtonSize.SMALL}
            {...props}
        >
            <Chevron direction={direction} className='h-3 md:h-5 md:w-5 ml-0' />
        </Button>
    )
}

export default ArrowButton
